<template>
	<div class="option form-group" :class="{ 'is-empty': empty, 'is-disabled': readonly }" :data-element="element.id"
		:title="readonly ? $t('app.common.readonly') : ''">
		<div class="d-flex justify-content-between align-items-center">
			<label class="element-label" :class="[classes('title'), hideTitle == true ? 'invisible' : '']"
				:title="required ? trans('buttons.required') : ''">
				<span v-html="macro(label)"></span>
				<small v-if="required" class="required">*</small>
			</label>
			<div v-if="fieldVisibleOnlyInPreview" class="app--engagement-advisor-preview-icon ms-2">
				<app-icon :title="trans('visibility.field.preview')" value="eye" type="fas" class="fa-sm" />
			</div>
		</div>
		<div class="option-row bg--options border--options" :class="{ 'is-invalid': !valid || invalid }">
			<div v-for="g in groups" class="pb-2">
				<div v-if="g.name" class="option-label" :class="classes('title')">{{ g.name }}</div>
				<div class="row g-2" :class="{ 'd-block': column }">
					<div v-for="i in rows(g)" class="col form-control" :class="classes('options')"
						@click="update(i.value)">
						<span v-if="!printing" v-show="checked(i.value)">
							<app-icon :value="multiple ? 'square-check' : 'circle-check'" class="primary"></app-icon>
						</span>
						<span v-if="!printing" v-show="!checked(i.value)">
							<app-icon :value="multiple ? 'square' : 'circle'"></app-icon>
						</span>
						<span :class="{ 'hide': !printing }">
							<input :type="multiple ? 'checkbox' : 'radio'" :checked="checked(i.value)"
								:name="element.id" />
						</span>
						<span class="label">{{ i.label }}</span>
					</div>
				</div>
			</div>
		</div>
		<input type="text" ref="input" class="position-absolute invisible" :value="value.join(',')"
			v-validate="validate" />
		<div class="invalid-feedback" :for="label" :class="{ 'd-block': !valid }">
			<span v-if="!valid">{{ $t('validation.mandatory') }}</span>
		</div>
		<small class="form-text" :class="classes('description')">
			<span v-if="description" v-html="macro(description)"></span>&nbsp;
		</small>
	</div>
</template>

<script>
import store from '../../store'

export default {
	props: {
		definition: { type: Object, required: true },
		element: { type: Object, required: true },
	},
	computed: {
		column() {
			return this.options('column') || store.state.template.legacy == true
		},
		description() {
			return typeof this.definition.description == 'string' ? this.definition.description : null
		},
		empty() {
			return this.value.length == 0
		},
		groups() {
			let s = this.options('structure');
			return s && s.groups ? s.groups : []
		},
		label() {
			return this.definition.title
		},
		multiple() {
			return this.options('multiple') == true
		},
		printing() {
			return store.state.printing == true
		},
		hideTitle() {
			return this.options('hideTitle') == true
		},
		readonly() {
			return store.getters.readonly(this.definition, !this.empty)
		},
		required() {
			return this.options('required') == true
		},
		valid() {
			return !(this.element && this.element.valid === false)
		},
		fieldVisibleOnlyInPreview() {
			return this.definition.print_visibility == 'preview' && store.state.preview == true && store.state.complete == false
		}
	},
	data() {
		return { value: [], invalid: false }
	},
	watch: {
		'element.value': {
			immediate: true,
			handler(value) {
				this.value = value && value instanceof Array ? value : []
			}
		}
	},
	methods: {
		checked(value) {
			return this.value.indexOf(value) !== -1
		},
		classes(index) {
			return store.getters['classes'](index)
		},
		macro(value) {
			return store.getters['macro'](value)
		},
		options(value) {
			return store.getters['options'](this.definition, value)
		},
		rows(group) {
			let items = []
			if (group && group.scope && group.scope == 'static') {
				items = group.items
			}
			if (group && group.scope && group.scope != 'static' && group.items) {
				items = store.getters['dynamicItems'](group.items[0].value, group.items[0].label)
			}
			return items
		},
		update(value) {
			if (this.element.value === null && !value) {
				return
			}
			if (!this.readonly) {
				if (this.checked(value)) {
					this.value = this.value.filter(v => v != value)
				} else if (!this.checked(value) && this.multiple) {
					this.value.push(value)
				} else if (!this.checked(value) && !this.multiple) {
					this.value = [value]
				}
				this.$refs.input.value = this.value.join(',')
				if (this.$validate({ target: this.$refs.input })) {
					let gk = this.element.group + '|' + this.definition.group
					store.commit('QUEUE', { id: this.element.id, group: gk, value: this.value })
				}
			}
		},
		validate(event) {
			if (this.required) {
				let m = event.target.value.length > 0 ? '' : this.$t('validation.required', { attribute: this.label })
				this.invalid = m.length > 0
				event.target.setCustomValidity(m)
			}
		},
		trans(key) {
			let trans = store.getters.trans(key)
			return trans ? trans : this.$t('front.' + key)
		}
	},
}
</script>
